import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../../../../services/settings.service';
import {ClientesComercio} from '../../../../_models/clientes-comercio';
import {MetodosServicio} from '../../../../_helpers/interfaces/metodos-servicio';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ClientesComercioService extends MetodosServicio<ClientesComercio> {

  constructor(
    public http: HttpClient,
    private settings: SettingsService
  ) {
    super(http, 'procesadora/clientes', ClientesComercio);
  }

  restartItem(): void {
    this.setItem(new ClientesComercio());
  }

  /**
   * Estado de sincronizacion
   * @returns observable que recupera estado de sincronizacion
   */
  getSincronizacionEstado(): Observable<any> {
    return this.http.get(`${this.settings.URL_BASE}public/sincronizacion_estado`);
  }

  obtenerListaCliente(filtro: any) {
    return this.http.post(this.settings.URL_BASE + 'fraccionate/procesadora/clientes', filtro);
  }
}
